import React from "react";

import SupportPageLayout from "./SupportPageLayout";
import RxAccordion from "@/components/ui/display/RxAccordion";

const faqItems = [
  {
    title: "I can't log into the Mayfair Club App",
    content: (
      <>
        Please make sure you are using the email address you used to complete
        your application form. If you are unsure of this email address, please
        contact{" "}
        <a href="mailto:allbrightmemberships@everywoman.com">
          allbrightmemberships@everywoman.com
        </a>
      </>
    ),
  },
  {
    title: "I can't log into my AllBright Digital account",
    content: (
      <>
        After signing up as a Mayfair Club member, you will still need to create
        an account for our Digital platform{" "}
        <a href="https://www.allbrightcollective.com/digital/register">here</a>
      </>
    ),
  },
  // {
  //   title: "I can't download the app",
  //   content: "Link to the App on an Android play store here. Link to the App store here.",
  // },
  {
    title: "I want to freeze my membership",
    content: (
      <>
        We offer a limited time that you can freeze your membership if you are
        traveling or on maternity/adoption leave. Please email:{" "}
        <a href="mailto:allbrightmemberships@everywoman.com">
          allbrightmemberships@everywoman.com
        </a>
      </>
    ),
  },
  {
    title: "I want to cancel a ticket for an event and a refund",
    content: (
      <>
        We only offer refunds to tickets purchased 24 hours prior to the event.
        Please email{" "}
        <a href="mailto:mayfairreservations@allbright.co">
          mayfairreservations@allbright.co
        </a>
      </>
    ),
  },
  {
    title: "I am a Club Member, and I can't buy a ticket to an event",
    content: (
      <>
        Please email{" "}
        <a href="mailto:mayfairreservations@allbright.co">
          mayfairreservations@allbright.co
        </a>
      </>
    ),
  },
  {
    title: "I want to host an event with AllBright",
    content: (
      <>
        Host an event form{" "}
        <a href="https://allbrightco.typeform.com/to/QlQgxbXN">here</a>
      </>
    ),
  },
  {
    title: "I want to refer a friend",
    content: (
      <>
        Refer a friend form{" "}
        <a href="http://members.allbrightcollective.com/form/440">here</a>
      </>
    ),
  },
  {
    title: "I want to make a reservation",
    content: (
      <>
        Reservation form:{" "}
        <a href="http://members.allbrightcollective.com/form/438">here</a>
      </>
    ),
  },
  {
    title: "I want to register a guest",
    content: (
      <>
        Guest form:{" "}
        <a href="http://members.allbrightcollective.com/form/417">here</a>
      </>
    ),
  },
  {
    title: "I want to make a complaint",
    content: (
      <>
        Complaint form:{" "}
        <a href="https://members.allbrightcollective.com/form/571?preview=yes">
          here
        </a>
      </>
    ),
  },
  {
    title: "I want to cancel my Club membership",
    content: (
      <>
        Please use the form{" "}
        <a href="https://members.allbrightcollective.com/form/954">here</a>
      </>
    ),
  },
];

const SupportTownhouse: React.FC = (): JSX.Element => {
  return (
    <SupportPageLayout>
      <RxAccordion items={faqItems} />
    </SupportPageLayout>
  );
};

export default SupportTownhouse;
